import { Box } from "@mui/material";
import React from "react";
import { InputField } from "../v3";

export const CreatePurchaseOrderForm = ({ details, vendors, users, onChange }) => {
  return (
    <>
      <Box className="fl gap-2">
        <InputField
          select={true}
          selectOptions={vendors}
          label="Vendor"
          name="vendor"
          value={details.vendor}
          onChange={onChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
        <InputField
          type="date"
          label="Date"
          name="date"
          value={details.date}
          onChange={onChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
        <InputField
          select={true}
          selectOptions={users}
          label="Assignee"
          name="assignee"
          value={details.assignee}
          onChange={onChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
        <InputField
          type="date"
          label="Required Date"
          name="requiredDate"
          value={details.requiredDate}
          onChange={onChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
      </Box>
    </>
  );
};
